import { useEffect, useState } from 'react';

/**
 * The current time, refreshed every `intervalMs`.
 *
 * Lets a page left open move on by itself: a registration window closing at
 * 23:59 changes the button without the visitor reloading.
 */
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
